import { CUSTOM_BTN_CHECKOUT_HOOK, getPriceDetails } from '../../utils';
import { ADDON_TYPE, PAGE } from '../../domain';
import { button, checkbox, qtyBox, qtyDropdown } from '../../templates';
import CssClasses from '../../template/common/cssClasses';

const KNOWN_CONTAINER_ID = 'upsell-container';

export function getImageDimension(cssProperty, dimension, reset, defaultVal) {
  if (reset) {
    return `${cssProperty}:initial!important;`;
  }

  if (dimension) {
    return `${cssProperty}:${dimension}px!important;`;
  }

  return defaultVal ? `${cssProperty}:${defaultVal}px;` : '';
}

export function getButtonPadding(paddingValue, defaultValue) {
  if (paddingValue === 0) {
    return 0;
  }
  return paddingValue || defaultValue || 1;
}

export function getImageUrl(options, addOnDetails, variantIndex) {
  const image =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0
      ? options.useThumbnailImage
        ? addOnDetails.variantOptions[variantIndex].originalSmallImage
        : addOnDetails.variantOptions[variantIndex].image
      : options.useThumbnailImage
      ? addOnDetails.originalSmallImage
      : addOnDetails.image;
  return image || '';
}

export function getPrices(options, addOnDetails, variantIndex) {
  const hasVariantOptions =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0;
  const compareAtPrice = hasVariantOptions
    ? addOnDetails.variantOptions[variantIndex].compareAtPrice
    : addOnDetails.compareAtPrice;
  const price = hasVariantOptions
    ? addOnDetails.variantOptions[variantIndex].price
    : addOnDetails.price;

  return getPriceDetails(options, price, compareAtPrice);
}

export function getUrl(addOnDetails, variantIndex) {
  const url =
    addOnDetails.variantOptions && addOnDetails.variantOptions.length > 0
      ? addOnDetails.variantOptions[variantIndex].url
      : addOnDetails.url;
  return url;
}

export function isVisible(e) {
  return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}

export function getQtyDropdownOptions(options) {
  if (options.quantityDropdownOptions) {
    return options.quantityDropdownOptions.split(',');
  }
  return [];
}

export function findForm(action) {
  const allForms = document.querySelectorAll('form');
  for (let i = 0; i < allForms.length; i++) {
    if (allForms[i].action && allForms[i].action.indexOf(action) >= 0) {
      return allForms[i];
    }
  }
}

export function getSubmitButton(options, form, page) {
  return page === PAGE.Product
    ? form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]') ||
        form.querySelector('.btn-addtocart') ||
        form.querySelector('button[name="add"]') ||
        form.querySelector('a.addtocart') ||
        form.querySelector('.product-form--add-to-cart') ||
        document.querySelector('.product-form__submit') ||
        (options.addToCartButtonSelector &&
          form.querySelector(options.addToCartButtonSelector))
    : form.querySelector(`[${CUSTOM_BTN_CHECKOUT_HOOK}='1']`) ||
        form.querySelector('button[name="checkout"]') ||
        form.querySelector('input[name="checkout"]') ||
        (options.checkoutButtonSelector &&
          form.querySelector(options.checkoutButtonSelector));
}

function getAddToCartInputTemplate(options, page) {
  const template =
    page === PAGE.Product
      ? options.productInputTemplate
      : options.cartInputTemplate;
  return template ? decodeURIComponent(template) : null;
}

export function getAddOnInput(
  options,
  page,
  addToCartButton,
  isGroupedVariant,
  productHandle,
  addOnDetails
) {
  const template = getAddToCartInputTemplate(options, page);
  let buttonQtyType = null;
  if (page === PAGE.Product) {
    if (options.quantitySelect) {
      return qtyBox({ isGroupedVariant, productHandle, addOnDetails });
    }

    if (options.addOnType === ADDON_TYPE.Dropdown) {
      const qtyOptions = getQtyDropdownOptions(options);
      if (qtyOptions.length > 0) {
        return qtyDropdown({
          isGroupedVariant,
          productHandle,
          options: qtyOptions,
          addOnDetails
        });
      }
    }

    if (options.addOnType === ADDON_TYPE.Checkbox) {
      return checkbox({
        isGroupedVariant,
        productHandle,
        template,
        addOnDetails
      });
    }
    buttonQtyType =
      options.addOnType === ADDON_TYPE.ButtonQtyBox ? ADDON_TYPE.QtyBox : null;
  } else {
    buttonQtyType = options.cartQtyType;
  }

  return button({
    original: addToCartButton,
    isGroupedVariant,
    productHandle,
    qtyType: buttonQtyType,
    addOnDetails
  });
}

export function getForm(page, options) {
  let cartForm;
  if (page === PAGE.Product) {
    if (options.productPageFormSelector) {
      cartForm = document.querySelector(options.productPageFormSelector);
    } else {
      const allForms = document.querySelectorAll('form[action="/cart/add"]');
      if (allForms.length === 1) {
        cartForm = allForms[0];
      } else {
        for (let i = 0; i < allForms.length; i++) {
          if (isVisible(allForms[i])) {
            cartForm = allForms[i];
            break;
          }
        }
      }

      if (!cartForm) {
        cartForm = findForm('/cart/add');
      }
    }
  }

  if (page === PAGE.Cart) {
    if (options.cartPageFormSelector) {
      cartForm = document.querySelector(options.cartPageFormSelector);
    } else {
      cartForm = document.querySelector('form[action="/cart"]');

      if (!cartForm) {
        cartForm = findForm('/checkout');
      }

      if (!cartForm) {
        cartForm = findForm('/cart');
      }
    }
  }

  return cartForm;
}

export function getAddOnBoxTemplate(options, page) {
  const template =
    page === PAGE.Product
      ? options.productAddOnTemplate
      : options.cartAddOnTemplate;
  return template ? decodeURIComponent(template) : null;
}

export function tryRenderInKnownContainer(loading) {
  const knownContainer = document.querySelector(`#${KNOWN_CONTAINER_ID}`);
  if (knownContainer) {
    knownContainer.insertAdjacentHTML('afterbegin', loading);
    return true;
  }
  return false;
}

export function removeUpsell() {
  const container = document.querySelector(`.${CssClasses.container}`);
  if (container) {
    container.remove();
  }
}
